import React, { useMemo } from 'react';
import { StyleSheet } from 'react-native';
import { useCssStyle } from '../../customHook/getCssStyle';

export const VideoHandler = (props) => {
  const { videoSrc, posterSrc, enableSound, style, showControls=false } = props;
  const getStyles = useCssStyle();

  return (
    <video
      poster={posterSrc}
      style={style}
      autoPlay={true}
      playsInline
      loop
      preload="true"
      enableSound={enableSound}
      controls={showControls}
      muted={!enableSound}
    >
      <source src={videoSrc} type="video/mp4" />
    </video>
  );
};